import { Flex, Progress, Text } from "@gravity-ui/uikit";
import { CounterType, RateLimitDto } from "definitions/counter-api";
import { useRateLimitFormatter } from "src/util/rateLimitFormatter";
import { formatExpiryText } from "src/util/timeFormatter";

import { useLimiterCardTranslate } from "./hooks/useLimiterCardTranslate";
import css from "./LimiterCard.module.scss";
import { getCounterTypeInfo } from "./utils/counterTypeInfo";
import {
  getThemeLimiterProgress,
  getPercent,
  getProgressText,
} from "./utils/limiterUtils";

interface LimiterCardProps {
  rateLimits?: Array<RateLimitDto>;
  countCompletedRequest: number | null;
  maxCompleteRequest: number | null;
  limitEndTime: string;
  type: CounterType;
}

export const LimiterCard = ({
  rateLimits,
  countCompletedRequest,
  maxCompleteRequest,
  limitEndTime,
  type,
}: LimiterCardProps) => {
  const translations = useLimiterCardTranslate();
  const { formatRateLimit } = useRateLimitFormatter();
  const counterInfo = getCounterTypeInfo(type);
  const IconComponent = counterInfo.icon;

  return (
    <div className={css.limiterCardContainer}>
      <Flex direction={"column"} gap={2} width={"100%"}>
        <Flex gap={6} justifyContent={"space-between"} alignItems={"center"}>
          <Flex direction={"column"} gap={1} width={"100%"}>
            <Flex gap={2} alignItems="center" className={css.counterTypeInfo}>
              <IconComponent width={16} height={16} />
              <Text variant="subheader-1" color="primary">
                {counterInfo.name}
              </Text>
            </Flex>

            {rateLimits && rateLimits.length > 0 && (
              <div className={css.limitationsSection}>
                <Text variant="subheader-1" color="primary">
                  {translations.limitations}:
                </Text>
                <div className={css.limitationsList}>
                  {rateLimits.map((rateLimit) => (
                    <div
                      key={`rateLimit_${rateLimit.type}`}
                      className={css.limitationItem}
                    >
                      <Text variant="subheader-1" color="warning-heavy">
                        {formatRateLimit(rateLimit.type, rateLimit.limit)}
                      </Text>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </Flex>
          <Progress
            className={css.progressbar}
            value={getPercent(countCompletedRequest, maxCompleteRequest)}
            text={getProgressText(
              countCompletedRequest,
              maxCompleteRequest,
              translations,
            )}
            theme={getThemeLimiterProgress(
              getPercent(countCompletedRequest, maxCompleteRequest),
            )}
          />
        </Flex>

        {/* Время истечения внизу на всю ширину */}
        <Text color="secondary" className={css.expiryText}>
          {formatExpiryText(limitEndTime, {
            expiresIn: translations.expiresIn,
            days: translations.days,
            hours: translations.hours,
            expired: translations.expired,
            expiresToday: translations.expiresToday,
          })}
        </Text>
      </Flex>
    </div>
  );
};
